import HeaderComponent from "../Header/HeaderComponent";
import HeaderDesktop from "../Header/HeaderDesktop";
import { useParams, useNavigate } from "react-router-dom";
import { useUser } from "../../hooks/useUser";
import { useSearchInstallment } from "../../hooks/fetch-data/useSearchInstallment";
import { getLoanList } from "../../utils/loan";
import styles from "./style.module.css";
import InstallmentReceipt from "./_components/InstallmentReceipt/InstallmentReceipt";
import { useTranslation } from "react-i18next";

import { useIsDesktop } from "../../hooks/useIsDesktop";

const MyLoanReceipt = () => {
  const navigate = useNavigate();
  const { loanId } = useParams();
  const { t } = useTranslation("myLoanReceipt");
  const { userData } = useUser();

  const { data: userLoanInfo } = useSearchInstallment(userData?.id);

  const loans = getLoanList(userLoanInfo);

  const loanInfo = loans?.find((l) => l.loan_id === parseInt(loanId));

  const isDesktop = useIsDesktop();

  if (!loanInfo) return <div>{t("notFound")}</div>;

  const paidInstallments = loanInfo.installments.filter(
    (installment) => installment?.state === "paid"
  );
  return (
    <div>
      {isDesktop ? (
        <HeaderDesktop title={t("header")} showIcon={true} onBack={true} />
      ) : (
        <HeaderComponent
          title={t("header")}
          onBack={() => {
            navigate(`/my-loans/${loanId}`);
          }}
        />
      )}
      <div className={styles.content}>
        <h1 className={styles.title}>
          {t("loanId")} {loanInfo.loan_name}
        </h1>
        <div className={styles.installmentList}>
          {paidInstallments.length > 0 ? (
            paidInstallments.map((installment, index) => (
              <InstallmentReceipt
                installment={installment}
                totalInstallments={loanInfo.installments.length}
                index={index}
                loanId={loanInfo.loan_id}
              />
            ))
          ) : (
            <div className={styles.noInstallment}>{t("noTransaction")}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyLoanReceipt;
